import { motion } from "framer-motion";
import { UserPlus, Palette, Rocket } from "lucide-react";

const steps = [
  {
    icon: UserPlus,
    step: "01",
    title: "Crie sua conta",
    desc: "Cadastre-se em segundos. Sem cartão de crédito, sem burocracia.",
    color: "from-primary/20 to-primary/5",
  },
  {
    icon: Palette,
    step: "02",
    title: "Monte seu cardápio",
    desc: "Adicione produtos, categorias, fotos e preços. Personalize tudo.",
    color: "from-primary/15 to-primary/5",
  },
  {
    icon: Rocket,
    step: "03",
    title: "Comece a vender",
    desc: "Compartilhe o link, imprima QR Codes e receba pedidos em tempo real.",
    color: "from-primary/10 to-primary/5",
  },
];

const HowItWorksSection = () => {
  return (
    <section id="how-it-works" className="py-24 bg-muted/30 relative">
      <div className="container">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 text-primary text-xs font-semibold uppercase tracking-wider mb-4">
            Como funciona
          </span>
          <h2 className="text-3xl md:text-5xl font-bold mt-3 mb-4">
            3 passos para <span className="text-gradient">começar</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          {steps.map((s, i) => (
            <motion.div
              key={i}
              className="relative"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.15 }}
            >
              {i < steps.length - 1 && (
                <div className="hidden md:block absolute top-12 left-[60%] w-[80%] h-px border-t-2 border-dashed border-primary/20" />
              )}
              <div className={`rounded-2xl bg-gradient-to-b ${s.color} border border-border p-8 text-center hover:shadow-glow transition-all`}>
                <div className="w-16 h-16 rounded-2xl bg-primary/10 border border-primary/20 flex items-center justify-center mx-auto mb-5 relative">
                  <s.icon className="h-7 w-7 text-primary" />
                  <span className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-gradient-primary text-primary-foreground text-xs font-bold flex items-center justify-center">
                    {s.step}
                  </span>
                </div>
                <h3 className="font-display font-bold text-lg mb-2">{s.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{s.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
